import React from "react";

const CaseStudies = () => {
  return (
    <div>
      <h1>This page will available soon...</h1>
    </div>
  );
};

export default CaseStudies;
